var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card", attrs: { shadow: "never" } },
        [
          _c("div", { staticClass: "tips" }, [
            _vm._v(" 用户用固定商户码抵扣时会先生成一张待确认核销单， "),
            _c("b", [_vm._v("确认后才真正扣积分、记你的应收")]),
            _vm._v(
              "。超过 " +
                _vm._s(_vm.timeoutHint) +
                " 未确认的单子会自动作废，积分原路解冻。 "
            ),
          ]),
          _c(
            "el-form",
            {
              attrs: { inline: "", size: "small" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "核销单号" } },
                [
                  _c("el-input", {
                    staticClass: "selWidth",
                    attrs: { clearable: "", placeholder: "核销单号 / 订单号" },
                    model: {
                      value: _vm.query.keyword,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.query,
                          "keyword",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "query.keyword",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.loading },
                      on: { click: _vm.onSearch },
                    },
                    [_vm._v("查询")]
                  ),
                  _c("el-button", { on: { click: _vm.onReset } }, [
                    _vm._v("重置"),
                  ]),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "auto-refresh",
                      model: {
                        value: _vm.autoRefresh,
                        callback: function ($$v) {
                          _vm.autoRefresh = $$v
                        },
                        expression: "autoRefresh",
                      },
                    },
                    [_vm._v("30 秒自动刷新")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { data: _vm.list, size: "small", border: "" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "序号", width: "60", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(_vm.$pageIndex(scope)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "verifyNo",
                  label: "核销单号",
                  "min-width": "180",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "类型", width: "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          _vm._s(row.type === "ORDER" ? "订单券码" : "积分抵扣")
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "uid", label: "用户 uid", width: "100" },
              }),
              _c("el-table-column", {
                attrs: { label: "订单金额", width: "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(_vm.yuan(row.orderAmount)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "deductPoints",
                  label: "抵扣积分",
                  width: "100",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "抵扣金额", width: "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(_vm.yuan(row.deductAmount)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "服务费", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(_vm.yuan(row.serviceFee)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "本店应收", width: "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("span", { staticClass: "receivable" }, [
                          _vm._v(_vm._s(_vm.yuan(row.receivable))),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "剩余确认时间", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "span",
                          {
                            class: _vm.remainSeconds(row) > 0 ? "" : "expired",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.remainSeconds(row) > 0
                                    ? _vm.remainSeconds(row) + " 秒"
                                    : "已超时"
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "发起时间",
                  "min-width": "150",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "90", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "text",
                              size: "small",
                              disabled: _vm.remainSeconds(row) <= 0,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.onConfirm(row)
                              },
                            },
                          },
                          [_vm._v(" 确认核销 ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "消费明细", "min-width": "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.items && row.items.length
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.goodsSummary(row.items))),
                            ])
                          : _c("span", { staticClass: "muted" }, [
                              _vm._v("未填写"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "page-sizes": _vm.$constants.page.limit,
                  "page-size": _vm.query.size,
                  "current-page": _vm.query.page,
                  layout: _vm.$constants.page.layout,
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.onSizeChange,
                  "current-change": _vm.onPageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "确认核销",
            visible: _vm.confirmVisible,
            width: "720px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.confirmVisible = $event
            },
          },
        },
        [
          _vm.current
            ? _c("div", { staticClass: "confirm-summary" }, [
                _vm._v(" 核销单 "),
                _c("b", [_vm._v(_vm._s(_vm.current.verifyNo))]),
                _vm._v(
                  "，订单金额 " +
                    _vm._s(_vm.yuan(_vm.current.orderAmount)) +
                    "， 扣除用户 "
                ),
                _c("b", [_vm._v(_vm._s(_vm.current.deductPoints))]),
                _vm._v(" 积分，本店应收 "),
                _c("b", { staticClass: "receivable" }, [
                  _vm._v(_vm._s(_vm.yuan(_vm.current.receivable))),
                ]),
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "items-title" },
            [
              _vm._v(" 消费明细 "),
              _c("span", { staticClass: "muted" }, [
                _vm._v("填写后用户在核销记录里能看到买了什么，不填也能核销"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "text", size: "mini" },
                  on: { click: _vm.addItem },
                },
                [_vm._v("+ 添加一行")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            { attrs: { data: _vm.items, size: "mini", border: "" } },
            [
              _c("el-table-column", {
                attrs: { label: "序号", width: "60", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(_vm.$pageIndex(scope)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "商品名称", "min-width": "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("el-input", {
                          attrs: {
                            size: "mini",
                            placeholder: "必填",
                            maxlength: "60",
                          },
                          model: {
                            value: row.productName,
                            callback: function ($$v) {
                              _vm.$set(
                                row,
                                "productName",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "row.productName",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "规格", width: "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("el-input", {
                          attrs: {
                            size: "mini",
                            placeholder: "选填",
                            maxlength: "40",
                          },
                          model: {
                            value: row.sku,
                            callback: function ($$v) {
                              _vm.$set(
                                row,
                                "sku",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "row.sku",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "单价(元)", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("el-input-number", {
                          attrs: {
                            size: "mini",
                            min: 0,
                            precision: 2,
                            "controls-position": "right",
                          },
                          model: {
                            value: row.unitPrice,
                            callback: function ($$v) {
                              _vm.$set(row, "unitPrice", $$v)
                            },
                            expression: "row.unitPrice",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "数量", width: "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("el-input-number", {
                          attrs: {
                            size: "mini",
                            min: 1,
                            max: 9999,
                            "controls-position": "right",
                          },
                          model: {
                            value: row.quantity,
                            callback: function ($$v) {
                              _vm.$set(row, "quantity", $$v)
                            },
                            expression: "row.quantity",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "小计", width: "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          _vm._s(
                            (
                              (row.unitPrice || 0) * (row.quantity || 0)
                            ).toFixed(2)
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "70" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var $index = ref.$index
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.items.splice($index, 1)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm.items.length
            ? _c("div", { staticClass: "items-total" }, [
                _vm._v("明细合计：" + _vm._s(_vm.itemsTotal) + " 元"),
              ])
            : _vm._e(),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.confirmVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    loading: _vm.submitting,
                  },
                  on: { click: _vm.submitConfirm },
                },
                [_vm._v("确认核销")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }